customElements.get("pop-menu") || customElements.define("pop-menu", class extends HTMLElement {
    constructor() {
        super();
        this.isInitialized = false;
        this.disclosures = [];
        this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    }

    connectedCallback() {
        if (this.isInitialized) return;

        this.querySelectorAll(".disclosure").forEach((disclosure) => {
            const button = disclosure.querySelector(":scope > button");
            const panel = disclosure.querySelector(":scope > .disclosure__list-wrapper");
            if (!button || !panel) return;

            const group = { button, panel, disclosure };
            this.disclosures.push(group);

            button.addEventListener("click", (e) => this.openSelector(e, group));
            button.addEventListener("focusout", (e) => this.closeSelector(e, group));
        });

        if (this.disclosures.length > 0) {
            this.elements = {
                button: this.disclosures[0].button,
                panel: this.disclosures[0].panel
            };
        }

        this.querySelectorAll("a").forEach(item =>
            item.addEventListener("click", this.onItemClick.bind(this))
        );

        this.isInitialized = true;
    }

    hide(group) {
        if (group) {
            group.button.setAttribute("aria-expanded", "false");
            group.panel.setAttribute("hidden", true);
        } else {
            this.disclosures.forEach(g => this.hide(g));
        }
    }

    hideAll(except = null) {
        this.disclosures.forEach(g => {
            if (g !== except) this.hide(g);
        });
    }

    onContainerKeyUp(event) {
        if (event.code.toUpperCase() === "ESCAPE") {
            this.disclosures.forEach(g => {
                if (g.button.getAttribute("aria-expanded") !== "false") {
                    this.hide(g);
                    event.stopPropagation();
                    g.button.focus();
                }
            });
        }
    }

    onItemClick(event) {
        // currently empty
    }

    openSelector(event, group) {
        this.hideAll(group);
        group.button.focus();
        group.panel.toggleAttribute("hidden");
        const expanded = group.button.getAttribute("aria-expanded") === "false";
        group.button.setAttribute("aria-expanded", expanded.toString());
    }

    closeSelector(event, group) {
        // Use setTimeout to let click/change events fire before checking focus
        setTimeout(() => {
            const focused = document.activeElement;
            const isInsidePanel = group.panel.contains(focused);
            const isInsideButton = group.button.contains(focused);
            const isRelatedInside = event.relatedTarget && (
                group.panel.contains(event.relatedTarget) ||
                group.button.contains(event.relatedTarget)
            );

            if (!isInsidePanel && !isInsideButton && !isRelatedInside) {
                this.hide(group);
            }
        }, 150);
    }
});